/**
 * This is the twofaAppController.
 * @memberOf twofaApp Module
 * @namespace twofaAppController
 */

/**
 * @name twofaAppController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param $log
 * @param $state
 * @param $window
 * @memberOf twofa Module.twofaAppController Controller
 * @ngInject
 */
function twofaAppController($scope, $translate, coreService, $log, $state, $window) {
  // Assign this controller as the view-model.
  // It will be accessible as 'twofaAppController' within the HTML template.
  var vm = this;
  vm.passCode = '';
  //methods
  vm.shouldDisableSubmit = shouldDisableSubmit;
  vm.getQrCodeImgSrc = getQrCodeImgSrc;
  vm.isPanelHidden = isPanelHidden;
  vm.togglePanel = togglePanel;


  //properties
  vm.qrCode = '';
  vm.has_errors = false;
  vm.showEmailError = false;
  vm.currentAppPanel = '';
  vm.qrCodeAsText = '';
  vm.qrCodeArray = [];

  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {

    vm.showEmailError = false;
    vm.authyPanelVisible = false;
    vm.duoPanelVisible = false;
    vm.lastPassPanelVisible = false;

    // Read Identity Server's data model
    var model = coreService.getIdentityModel();
    if(model == null || typeof(model.data) === 'undefined'){
      $state.go('error');
    }

    $scope.model = model;
    vm.qrCode = $scope.model.data.qrCode;
    vm.qrCodeAsText = $scope.model.data.qrCodeAsText;
    vm.has_errors = $scope.model.has_errors;
    vm.authenticatorPanelVisible = false;
    vm.showQRCodeAsText = false;
    vm.showAuthenticatorAppPanel = showAuthenticatorAppPanel;
    vm.hideAuthenticatorAppPanel = hideAuthenticatorAppPanel;
    vm.displayQRCodeAsText = displayQRCodeAsText;
    vm.twofactorsection = "twofasection twofasection-wider twofa-app";
    vm.googleAppStoreUrl = buildGoogleAppStoreUrl();
    vm.appleAppStoreUrl = buildAppleAppStoreUrl();
    vm.errorMessage= model.errorMessage;
    vm.twofactorselections =  $scope.model.two_factor_selections;
    vm.validateForm = validateForm;
    vm.passcodeOnBlur = passcodeOnBlur;
    vm.closeOnBlur = closeOnBlur;

    if(vm.qrCodeAsText)
    {
      vm.qrCodeArray = vm.qrCodeAsText.split(''); //this is to support WAI
    }

     //Setup translation    
  let stateCheck = setInterval(() => {
    if ($window.document.readyState === 'complete') {  
      clearInterval(stateCheck);        
      $translate(['twofa.registration.form.header', 'twofa.registration.form.intro_text', 'twofa.registration.form.code_input', 
      'twofa.registration.form.twofa_unable_toscan_text', 'twofa.registration.form.close_link', 'twofa.registration.form.twofa_unable_toscan_tooltip', 'twofa.registration.authenticatorapps.recommend_message', 
      'twofa.registration.authenticatorapps.supported_apps', 'twofa.registration.authenticatorapps.supported_apps_duomobile_heading',
      'twofa.registration.authenticatorapps.supported_apps_authy_heading', 'twofa.registration.authenticatorapps.supported_apps_lastpass_heading', 
      'twofa.registration.form.view_supported_apps'        
    ]) 
      .then(function(data) {
          vm.data = data; 
          if(vm.has_errors)
          {
            setAriaLabelOnLoad(false, 'passCode');
          }
          else
          {
            setAriaLabelOnLoad(true, 'passCode');
          }        
          setFocus("passCode");   
      });          
    }
  }, 0);

  }
    
  function passcodeOnBlur(e){    
    setAriaLabelOnLoad(false, 'passCode')
  }

  function closeOnBlur(e){    
    setAriaLabelForLinks(vm.data['twofa.registration.form.close_link'], 'closeId');
  }

  function setFocus(id)
  {
    var element = $window.document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      $window.setTimeout(function(){ element.focus(); }, 0);
    }      
  }

  function setAriaLabelOnLoad(enable, id)
  {
    var element = document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      var arialDescriptionText = vm.data['twofa.registration.form.code_input'];
      if (enable)
      {
        arialDescriptionText = vm.data['twofa.registration.form.header'] + '. ' + vm.data['twofa.registration.form.intro_text'] + vm.data['twofa.registration.form.code_input'];
      }

      element.setAttribute('aria-label', arialDescriptionText);
    }
  }

  function setAriaLabelForLinks(text, id)
  {
    var element = document.getElementById(id);
    element.setAttribute('aria-label', text);
  }
 
  function hideAuthenticatorAppPanel() {
    vm.authenticatorPanelVisible = false;
    vm.twofactorsection = "twofasection twofasection-wider twofa-app";    
    setFocus('supportedId');
    setAriaLabelForLinks(vm.data['twofa.registration.form.view_supported_apps'], 'supportedId');
  }

  function showAuthenticatorAppPanel() {
    vm.twofactorsection = "twofasection-expanded twofa-app";
    vm.currentAppPanel = '';
    vm.authenticatorPanelVisible = true;
    setFocus('closeId');
    setAriaLabelForLinks(vm.data['twofa.registration.authenticatorapps.recommend_message'] 
    + vm.data['twofa.registration.authenticatorapps.supported_apps'] 
    + '. '+ vm.data['twofa.registration.authenticatorapps.supported_apps_duomobile_heading']
    + '. '+ vm.data['twofa.registration.authenticatorapps.supported_apps_authy_heading']
    + '. '+ vm.data['twofa.registration.authenticatorapps.supported_apps_lastpass_heading']
    , 'closeId');
  }

  function shouldDisableSubmit() {
    return vm.passCode === '';
  }

  function getQrCodeImgSrc() {
    return "data:image/JPEG;base64," + vm.qrCode;
  }

  function buildGoogleAppStoreUrl() {
    return 'images/google/' + getlocales() + '/play-badge.png';
  }

  function buildAppleAppStoreUrl() {
    return 'images/apple/' + getlocales() + '/Download_on_the_App_Store_Badge_135x40.svg';
  }

  function getlocales(){
    if($scope.model.ui_locales === 'en-us' || $scope.model.ui_locales === 'en-gb'){
      return 'en';
    }

    return $scope.model.ui_locales;
  }

  function togglePanel(panel) {
    if (vm.currentAppPanel === panel) {
      vm.currentAppPanel = '';
    } else {
      vm.currentAppPanel = panel;
    }
  }

  function displayQRCodeAsText() {
      vm.showQRCodeAsText = true;
      setFocus('passCode');
      setAriaLabelForLinks(vm.data['twofa.registration.form.twofa_unable_toscan_tooltip'] 
      +  vm.qrCodeArray
      , 'passCode');
  }

  function isPanelHidden(panel) {
    return vm.currentAppPanel !== panel;
  }

  function validateForm(e) {
        if (vm.passCode === '') {
          // Do not submit
          e.preventDefault();
        }
  }

}

export default twofaAppController;


// WEBPACK FOOTER //
// ./src/login/2fa/app/2fa.app.controller.js